module.exports = __webpack_public_path__ + "img/bathroomSpace1.a5310c4f.png";